import { render, staticRenderFns } from "./PODs.vue?vue&type=template&id=31044884&scoped=true&"
import script from "./PODs.vue?vue&type=script&lang=js&"
export * from "./PODs.vue?vue&type=script&lang=js&"
import style0 from "./PODs.vue?vue&type=style&index=0&id=31044884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31044884",
  null
  
)

export default component.exports